<template>
	<div
		class="g-header-files-preview"
		:class="{ 'is-single': items.length === 1, 'is-multiple': items.length > 1 }"
	>
		<template v-if="items.length === 1 && !forceListLayout">
			<div class="g-header-files-preview__single">
				<div class="g-header-files-preview__single-main">
					<div class="g-header-files-preview__icon is-large" aria-hidden="true">
						<img
							:src="getFileIconUrl(items[0])"
							class="g-header-files-preview__icon-img"
							:alt="getFileIconMark(items[0])"
						/>
					</div>
					<div class="g-header-files-preview__single-name">{{ items[0].filename }}</div>
					<div class="g-header-files-preview__single-size">{{ items[0].filesize }}</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="g-header-files-preview__list">
				<div
					v-for="(item, index) in items"
					:key="item.id"
					class="g-header-files-preview__item"
					:class="{ 'is-clickable': canViewFile(item) }"
					@click="onViewFile(item, $event)"
				>
					<div class="g-header-files-preview__icon" aria-hidden="true">
						<img
							:src="getFileIconUrl(item)"
							class="g-header-files-preview__icon-img"
							:alt="getFileIconMark(item)"
						/>
					</div>
					<div class="g-header-files-preview__info">
						<div class="g-header-files-preview__name">{{ item.filename }}</div>
						<div class="g-header-files-preview__size">{{ item.filesize }}</div>
					</div>
					<div
						v-if="index < items.length - 1"
						class="g-header-files-preview__divider"
					></div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	import { LOCAL_ASSET } from '../utils/localAssets.js';
	import { getMediaItemUrl } from '../utils/qiniuMedia.js';
	import { getPayFileUnlockFileIconKey, getPayFileUnlockFileIconMark } from '../utils/payFileUnlock.js';

	export default {
		name: 'GHeaderFilesPreview',
		props: {
			items: {
				type: Array,
				default: () => [],
			},
			forceListLayout: {
				type: Boolean,
				default: false,
			},
			editable: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['edit'],
		methods: {
			getFileIconMark(item) {
				const filename = item?.filename || '';
				if (item?.previewUrl && /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(filename)) {
					return '图片';
				}
				return getPayFileUnlockFileIconMark(filename);
			},
			getFileIconUrl(item) {
				const filename = item?.filename || '';
				if (item?.previewUrl && /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(filename)) {
					return item.previewUrl;
				}
				const key = getPayFileUnlockFileIconKey(filename);
				return LOCAL_ASSET.payFileIcons[key] || LOCAL_ASSET.payFileIcons.file;
			},
			canViewFile(item) {
				return Boolean(item?.url || item?.previewUrl);
			},
			onViewFile(item, event) {
				if (!this.canViewFile(item) || this.editable) return;
				event.stopPropagation();
				const url = getMediaItemUrl(item);
				if (!url) return;
				window.open(url, '_blank');
			},
		},
	};
</script>

<style scoped lang="less">
	.g-header-files-preview {
		width: 100%;
	}

	.g-header-files-preview__single {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 140px;
		padding: 20px 24px 20px 24px;
		box-sizing: border-box;
	}

	.g-header-files-preview__single-main {
		display: flex;
		flex-direction: column;
		align-items: center;
		max-width: 100%;
	}

	.g-header-files-preview__icon {
		flex-shrink: 0;
		width: 56px;
		height: 56px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;

		&.is-large {
			width: 56px;
			height: 56px;
			.g-header-files-preview__icon-img {
				width: 56px;
				height: 56px;
			}
		}
	}

	.g-header-files-preview__icon-img {
		width: 45px;
		height: 45px;
		object-fit: contain;
	}

	.g-header-files-preview__single-name {
		margin-top: 12px;
		max-width: 100%;
		font-size: 13px;
		color: #333;
		line-height: 1.4;
		text-align: center;
		word-break: break-all;
	}

	.g-header-files-preview__single-size {
		margin-top: 6px;
		font-size: 12px;
		color: #999;
		line-height: 1.4;
	}

	

	.g-header-files-preview__list {
		margin: 0 18px;
		border: 1px solid #eee;
		border-radius: 4px;
		background: #fff;
		overflow: hidden;
	}

	.g-header-files-preview__item {
		position: relative;
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 14px 16px;

		&.is-clickable {
			cursor: pointer;

			&:hover {
				background: #fafafa;
			}

			&:active {
				background: #f0f0f0;
			}
		}
	}

	.g-header-files-preview__info {
		min-width: 0;
		flex: 1;
	}

	.g-header-files-preview__name {
		font-size: 13px;
		color: #333;
		line-height: 1.4;
		word-break: break-all;
	}

	.g-header-files-preview__size {
		margin-top: 4px;
		font-size: 12px;
		color: #999;
		line-height: 1.4;
	}

	.g-header-files-preview__divider {
		position: absolute;
		left: 16px;
		right: 16px;
		bottom: 0;
		height: 1px;
		background: #f0f0f0;
	}

	// H5 适配
	@media (max-width: 768px) {
		.g-header-files-preview__list {
			margin: 0;
			border-radius: 0;
		}
	}
</style>
